var _a;
import { __assign, __extends, __rest } from "tslib";
import React, { PureComponent, createRef, } from 'react';
import { withRegistry, ComponentRegistryConsumer } from '@bem-react/di';
import { Keys, isKeyCode } from '../../lib/keyboard';
import { mergeAllRefs } from '../../lib/mergeRefs';
import { selectRegistry } from './Select.registry/desktop';
import { Select as SelectCommon, cnSelect } from './Select';
var POPUP_DIRECTIONS = ['bottom-left', 'bottom-right', 'top-left', 'top-right'];
var defaultProps = {
    value: ''
};
var SelectPresenter = (_a = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = { popupMinWidth: 0, maxMenuHeight: _this.props.maxHeight };
            _this.drawingParams = [];
            /**
             * Контейнер с ссылкой на корневой DOM элемент селекта.
             */
            _this.innerRef = createRef();
            /**
             * Контейнер с ссылкой на корневой DOM элемент меню.
             */
            _this.menuRef = createRef();
            /**
             * Контейнер с ссылкой на DOM элемент триггера.
             */
            _this.triggerRef = createRef();
            /**
             * Контейнер с ссылкой на DOM элемент попапа.
             */
            _this.popupRef = createRef();
            /**
             * Флаг, предотвращающий закрытие меню после клика в скроллбар (нужен исключительно для ie11).
             *
             * @see https://st.yandex-team.ru/ISL-7610
             */
            _this.preventClosable = false;
            _this.subscribeToEvents = function () {
                document.addEventListener('mousedown', _this.onDocumentMouseDown);
                window.addEventListener('resize', _this.onWindowChange);
                window.addEventListener('orientationchange', _this.onWindowChange);
            };
            _this.unsubscribeFromEvents = function () {
                document.removeEventListener('mousedown', _this.onDocumentMouseDown);
                window.removeEventListener('resize', _this.onWindowChange);
                window.removeEventListener('orientationchange', _this.onWindowChange);
            };
            _this.onDocumentMouseDown = function (event) {
                var popupNode = _this.popupRef.current;
                if (popupNode !== null && popupNode.contains(event.target)) {
                    _this.preventClosable = true;
                    event.preventDefault();
                }
            };
            _this.onEscapeKeyDown = function () {
                if (_this.props.setOpened !== undefined) {
                    _this.props.setOpened(false);
                }
            };
            _this.onWindowChange = function () {
                if (_this.props.setOpened !== undefined) {
                    _this.props.setOpened(false);
                }
            };
            _this.onBlur = function (event) {
                if (_this.preventClosable) {
                    _this.preventClosable = false;
                    return;
                }
                if (_this.props.setOpened !== undefined) {
                    _this.props.setOpened(false);
                }
                if (_this.props.onBlur !== undefined) {
                    _this.props.onBlur(event);
                }
            };
            _this.onClick = function (event) {
                if (_this.props.setOpened !== undefined) {
                    _this.props.setOpened(!_this.props.opened);
                }
                if (_this.props.onClick !== undefined) {
                    _this.props.onClick(event);
                }
            };
            _this.onKeyDown = function (event) {
                if (isKeyCode(event.keyCode, [Keys.ENTER])) {
                    // Делаем поведение как у нативного селекта,
                    // он открывается только по клавишам space, up, down.
                    event.preventDefault();
                }
                if (isKeyCode(event.keyCode, [Keys.UP, Keys.DOWN])) {
                    event.preventDefault();
                    if (_this.props.setOpened !== undefined) {
                        _this.props.setOpened(true);
                    }
                }
                if (isKeyCode(event.keyCode, [Keys.SPACE])) {
                    if (_this.props.setOpened !== undefined) {
                        event.preventDefault();
                        if (!_this.props.opened) {
                            _this.props.setOpened(true);
                        }
                    }
                }
                if (_this.props.opened && _this.props.onKeyDown !== undefined) {
                    _this.props.onKeyDown(event);
                }
            };
            _this.onMenuChange = function (event) {
                if (_this.props.onChange !== undefined) {
                    _this.props.onChange(event);
                }
                if (_this.props.setOpened !== undefined) {
                    if (!Array.isArray(_this.props.value)) {
                        _this.props.setOpened(false);
                    }
                }
                if (_this.preventClosable) {
                    _this.preventClosable = false;
                }
            };
            _this.setMenuMaxHeight = function () {
                if (_this.menuRef.current === null) {
                    return;
                }
                var bestHeight = 0;
                var menuWidth = _this.menuRef.current.getBoundingClientRect().width;
                _this.drawingParams.forEach(function (params) {
                    if (params.width >= menuWidth && params.height > bestHeight) {
                        bestHeight = params.height;
                    }
                });
                if (bestHeight > 0) {
                    _this.setState({
                        maxMenuHeight: _this.props.maxHeight ? Math.min(_this.props.maxHeight, bestHeight) : bestHeight
                    });
                }
            };
            _this.onGetPossibleDrawingParams = function (drawingParams) {
                _this.drawingParams = drawingParams;
            };
            return _this;
        }
        class_1.prototype.componentDidMount = function () {
            this.forwardRefs();
        };
        class_1.prototype.componentWillUnmount = function () {
            this.unsubscribeFromEvents();
        };
        class_1.prototype.componentDidUpdate = function (prevProps) {
            this.forwardRefs();
            if (!prevProps.opened && this.props.opened) {
                this.subscribeToEvents();
            }
            else if (prevProps.opened && !this.props.opened) {
                this.unsubscribeFromEvents();
            }
            var isChangeOpened = !prevProps.opened && this.props.opened;
            var inChangeValue = Array.isArray(this.props.value) && prevProps.value.length !== this.props.value.length;
            if (isChangeOpened || inChangeValue) {
                this.setPopupMinWidth();
            }
            if (this.drawingParams) {
                this.setMenuMaxHeight();
            }
        };
        class_1.prototype.render = function () {
            var _this = this;
            var _a = this.props, addonAfter = _a.addonAfter, maxHeight = _a.maxHeight, opened = _a.opened, options = _a.options, popupRef = _a.popupRef, size = _a.size, theme = _a.theme, _b = _a.unsafe_scope, unsafe_scope = _b === void 0 ? this.innerRef : _b, value = _a.value, view = _a.view, props = __rest(_a, ["addonAfter", "maxHeight", "opened", "options", "popupRef", "size", "theme", "unsafe_scope", "value", "view"]);
            var _c = this.state, popupMinWidth = _c.popupMinWidth, maxMenuHeight = _c.maxMenuHeight;
            var popupMainOffset = view ? 2 : 5;
            return (React.createElement(ComponentRegistryConsumer, { id: cnSelect() }, function (_a) {
                var Popup = _a.Popup, Menu = _a.Menu;
                return (React.createElement(SelectCommon, __assign({}, props, { triggerRef: _this.triggerRef, innerRef: mergeAllRefs(_this.innerRef, _this.props.innerRef), onBlur: _this.onBlur, onClick: _this.onClick, onKeyDown: _this.onKeyDown, options: options, size: size, theme: theme, value: value, view: view, opened: opened, addonAfter: React.createElement(React.Fragment, null,
                        React.createElement(Popup, { target: "anchor", anchor: _this.triggerRef, className: cnSelect('Popup'), directions: POPUP_DIRECTIONS, mainOffset: popupMainOffset, view: view, style: { minWidth: popupMinWidth }, theme: theme, visible: opened, innerRef: mergeAllRefs(_this.popupRef, _this.props.popupRef), onEscapeKeyDown: _this.onEscapeKeyDown, getPossibleDrawingParams: _this.onGetPossibleDrawingParams, scope: unsafe_scope },
                            React.createElement(Menu, { width: "max", className: cnSelect('Menu'), style: { maxHeight: maxMenuHeight }, focused: opened, items: options, onChange: _this.onMenuChange, size: size, theme: theme, value: value, view: view, innerRef: _this.menuRef })),
                        addonAfter) })));
            }));
        };
        /**
         * Копирует ссылки на DOM узлы для дальнейшего использования.
         */
        class_1.prototype.forwardRefs = function () {
            mergeAllRefs(this.props.triggerRef)(this.triggerRef.current);
        };
        class_1.prototype.setPopupMinWidth = function () {
            var _this = this;
            var triggerNode = this.triggerRef.current;
            if (triggerNode !== null) {
                // Получаем размеры триггера в следующем тике,
                // т.к. в нем могут быть изменения влияющие на его размер.
                requestAnimationFrame(function () {
                    _this.setState({ popupMinWidth: triggerNode.clientWidth });
                });
            }
        };
        return class_1;
    }(PureComponent)),
    _a.displayName = cnSelect() + "@desktop",
    _a);
export * from './Select';
export var Select = withRegistry(selectRegistry)(SelectPresenter);
